import { Box, Text, Flex, Hide } from '@galilee/lilee';
import { StyledSubtitle, UnmarginedPanel, InlineText, ItemTitle } from "./index";
import styled from 'styled-components';

const PexaParticipantContainer = styled(Box)`
    display : grid;
    grid-template-rows: 1fr;
    grid-template-columns: 40% 20% 20% 20%;
    justify-content: space-between;
    @media screen and (max-width: ${(p) => p.theme.breakpointsMax[4]}) {
        grid-template-columns: 1fr;
    }
`;
const Header = styled(Box)`
    display : grid;
    grid-template-rows: 1fr;
    grid-template-columns: 40% 20% 20% 20%;
    justify-content: space-between;
    border-bottom: 1px solid ${(p) => p.theme.colors.base10};
`;
const PexaParticipantCard = ({ pexaParticipants }) => {
    const renderStatus = (settlementAcceptanceStatus) => {
        if (settlementAcceptanceStatus === 'Accepted')
            return <Text color="success" fontSize="0">{settlementAcceptanceStatus}</Text>;        
        else return <Text fontSize="0">{settlementAcceptanceStatus}</Text>;        
    };
    return (
        <UnmarginedPanel id="pexaParticipants">
            <Flex justifyContent="space-between">
                <StyledSubtitle>PEXA Participants</StyledSubtitle>                
            </Flex>
            <Header>
                <ItemTitle>Name</ItemTitle>
                <Hide breakpoints={[0, 1, 2, 3, 4]}>
                    <ItemTitle>Workspace</ItemTitle>
                </Hide>
                <Hide breakpoints={[0, 1, 2, 3, 4]}>
                    <ItemTitle>Role</ItemTitle>
                </Hide>
                <Hide breakpoints={[0, 1, 2, 3, 4]}>
                    <ItemTitle>Settlement Date/Time</ItemTitle>
                </Hide>
            </Header>
            <Flex flexDirection="column">
                {pexaParticipants?.map((pexaParticipants, idx) => (
                    <PexaParticipantContainer key={pexaParticipants.participantName + idx} mt="4">
                        <Flex alignItems="flex-start" mb="1">                            
                            <InlineText>{pexaParticipants.participantName}</InlineText>
                        </Flex>                                                  
                        <InlineText alignItems="flex-start">{pexaParticipants.workspaceId}</InlineText>       
                        <InlineText alignItems="flex-start">{pexaParticipants.roleName}</InlineText>                            
                        <InlineText alignItems="flex-start">{renderStatus(pexaParticipants.settlementAcceptanceStatus)}</InlineText>  
                    </PexaParticipantContainer>
                ))}
            </Flex>
        </UnmarginedPanel>
    );
};

export default PexaParticipantCard;